import { fetchFirstPageCardIds, PAGE_SIZE } from './shared';
import { deleteCards } from '@vlabs/api/point-api/client';

export async function deleteAllCardsFromList(listId: string): Promise<void> {
  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const cardIds = await fetchFirstPageCardIds(listId);

    if (cardIds.length === 0) return;

    // eslint-disable-next-line no-await-in-loop
    await deleteCards({ card_ids: cardIds }, { ignore: 1 });

    if (cardIds.length < PAGE_SIZE) return;
  }
}
